import React, { useEffect, useState } from "react";
import GradingCategoryForm from "./GradingCategoryForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/gradingCategoryActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const GradingCategoryEdit = props => {
    const { classes, gradingCategory, onFetchGradingCategory, onFetchGradingCategoryInit, activeCustomerID, translations, permissions, onEditGradingCategory } = props;
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await onFetchGradingCategory({ ActiveCustomerID: activeCustomerID, GradingCategoryID: parseURL(window.location.href).GradingCategoryID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchGradingCategoryInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["GradingCategoryID"] = gradingCategory.GradingCategoryID;
        let result = await onEditGradingCategory({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        Product: gradingCategory.Product || "",
    };

    let formSettings = {
        Validation: {
            Product: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_grading_category"] || "Edit grading category",
        ButtonSubmit: hasPermission(permissions, "grading_category_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data ?
                <GradingCategoryForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        gradingCategory: state.admin.gradingCategory && state.admin.gradingCategory.loaded ? state.admin.gradingCategory.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchGradingCategoryInit: gradingCategory => dispatch(actions.loadGradingCategoryInit(gradingCategory)),
        onFetchGradingCategory: gradingCategory => dispatch(actions.loadGradingCategory(gradingCategory)),
        onEditGradingCategory: gradingCategory => dispatch(actions.editGradingCategory(gradingCategory)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GradingCategoryEdit));
